import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import Highlighter from 'react-highlight-words';
import classnames from 'classnames';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';
import useResourceTree from '@/shared/hooks/resource/useResourceTree';
import { retrieveResources } from '@/shared/components/registration/resourceApi';
const messages = defineMessages({
    EnterResource: {
        id: 'EnterResource',
        defaultMessage: 'Enter resource',
    },
});
export const ResourceMultiSelect = ({ selection, resourceTypes = null, resourceType = -1, onChange, placeholder, small = false, }) => {
    const intl = useIntl();
    const [allResources, setResources] = useState([]);
    const resources = useMemo(() => {
        if (!resourceTypes || resourceTypes.length === 0)
            return allResources;
        return allResources.filter(r => resourceTypes.includes(r.type));
    }, [resourceTypes, allResources]);
    const items = useResourceTree(resources, intl);
    useEffect(() => {
        retrieveResources(intl, resourceType).then(response => {
            setResources(response);
        });
    }, [intl]);
    const renderItem = useCallback((item, searchValue, index) => {
        const showCategory = item.level === 1 && (index === 0 || item.categoryId !== items[index - 1].categoryId);
        return (_jsxs("div", { children: [showCategory ? (_jsx("div", Object.assign({ className: "margin-10L" }, { children: searchValue ? (_jsx(Highlighter, { highlightClassName: "bold", searchWords: [searchValue], textToHighlight: item.categoryLabel })) : (item.categoryLabel) }))) : null, _jsx("div", Object.assign({ className: classnames({
                        'margin-10L': item.level === 0,
                    }) }, { children: searchValue ? (_jsx(Highlighter, { highlightClassName: "bold", searchWords: [searchValue], textToHighlight: item.label })) : (item.label) }))] }));
    }, [items]);
    const [selectedItems, selectableItems] = splitItems(items, selection);
    return (_jsx(MultiSelect, { selectedItem: selectedItems, onItemRemoved: item => onChange(removeItem(selection, item)), onItemSelected: item => onChange(addItem(selection, item)), items: selectableItems, placeholder: placeholder || intl.formatMessage(messages.EnterResource), isSmall: small, renderItem: renderItem, searchProps: ['search', 'label'] }));
};
export default ResourceMultiSelect;
